import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Store } from '../interfaces/Store';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SiteViwModel } from '../interfaces/SiteViewModel';


@Injectable({
    providedIn: 'root'
})
export class StoreService {

    // subscriptions


    address = ''; // '140 London Road, Hazel Grove';
    email = ''; // 'info@s.com';
    phone = ['', ''];
    hours = ''; // 'Mon-Sat 10:00pm - 7:00pm';
    text = '';
    store: Store;

    multilanguage = true;
    multicurrency = false;

    constructor(private apiServices: ApiService) {
        this.load();
    }

    load() {
        const date = localStorage.getItem('store_DATE');
        console.log(date);
        try {
            // if (date !== undefined) {
            //     if (moment().unix() < (this.getExpiration())) {
            //         this.binding();
            //         return;
            //     }
            // }
            this.apiServices.getStore().subscribe(x => {

                localStorage.setItem('store', JSON.stringify(x));
                const exp = moment().unix() + 2 * 60;
                localStorage.setItem('store_DATE', exp.toString());
                this.store = x as Store;

                this.binding();

            });
        } catch {

        }
    }

    get primaryPhone(): string | null {
        return this.phone.length > 0 ? this.phone[0] : null;
    }

    getExpiration() {
        const expiration = localStorage.getItem('store_DATE');
        const expiresAt = JSON.parse(expiration);

        return expiresAt;
    }
    public IsMultiLanguage(): boolean {
        return this.multilanguage;
    }
    public IsMultiCurrency(): boolean {
        return this.multicurrency;
    }
    public getKeywords(key): string {
        let value = '';
        try {
            if (localStorage.getItem('store')) {
                const store = JSON.parse(localStorage.getItem('store')) as SiteViwModel;
                value = store.keywords.find(x => x.key.toLowerCase() === key.toLowerCase()).value;
            }
        } catch {
            value = key;
        }
        return value?.split('_').join(' ');
    }
    public getContent(key): string {
        let value = '';
        try {
            if (localStorage.getItem('store')) {
                const store = JSON.parse(localStorage.getItem('store')) as SiteViwModel;
                const obj = store.pages.find(x => x.name.toLowerCase() === key.toLowerCase());
                console.log(obj);
                if (obj) {
                    value = obj.content;
                }

            }
        } catch (error) {
            value = '-1';
            console.log(error);
        }
        return value;
    }

    Load() {

    }

    GetStore(): Observable<Store> {
        return this.apiServices.getStore().pipe(
            map(x => {

                localStorage.setItem('store', JSON.stringify(x));
                const exp = moment().unix() + 2 * 60;
                localStorage.setItem('store_DATE', exp.toString());
                this.store = x as Store;

                return this.store;

            })
        );
    }

    binding() {
        try {

            this.store = JSON.parse(localStorage.getItem('store')) as Store;
        } catch { }
    }

}
